import { Col, Row } from "antd";
import { useNavigate } from "react-router-dom";
import subscriptionImage from "../../../assets/staticImages/badge.png";
import { SubmitButton, TextComponent } from "../../../components";
import styles from "./Membership.module.css";
import { roles } from "../../../config/roles";
import Storage from "../../../utills/AsyncStorage";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { PaymentMiddleware } from "../../../Store/Middlewares/PaymentMiddleware";
import { showAlert } from "../../../Store/Actions/GeneralActions";
import moment from "moment";

const membershipPlansVendor = [
  { title: "Basic", subtitle: "Advertise Service", price: "9.99" },
  {
    title: "Premium",
    subtitle: "Add multiple vendor accounts",
    subtitle2: "Advertise Service",
    price: "19.99",
  },
];

const membershipPlansClient = [
  {
    title: "Monthly Subscription",
    subtitle:
      "Subscribe now & get an access to create unlimited event in just ",
    price: "9.99",
  },
];

const MembershipComp = ({ plan }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const onSubscribed = () => {
    dispatch(
      showAlert({
        type: "Warning",
        message: "Already Subscribed",
      })
    );
  };
  return (
    <Row className={styles.subscriptionContainer}>
      <Col xs={24} md={14} className={styles.leftContainer}>
        <div className={styles.textContainer}>
          <h2>
            <TextComponent>{plan?.name}</TextComponent>
          </h2>
          <div>
            <h5>
              <TextComponent>{plan?.description}</TextComponent>
            </h5>
            {/* {plan.subtitle2 ? (
              <h5>
                <TextComponent>{plan.subtitle2}</TextComponent>
              </h5>
            ) : (
              ""
            )} */}
          </div>
          <TextComponent textClass={styles.disc_text}>
            ${plan?.discounted_price == 0 ? plan?.price : plan?.discounted_price}
          </TextComponent>
          <TextComponent textClass={styles.disc_price_text}>Before ${plan?.price}</TextComponent>
          <TextComponent>Get {plan?.discount_percent}% off</TextComponent>
          <TextComponent>
            From {moment(plan?.discount_start_date).format("DD MMMM")} to{" "}
            {moment(plan?.discount_end_date).format("DD MMMM")}
          </TextComponent>
        </div>
        <Row>
          <SubmitButton
            title={plan?.is_already_subscribed ? "Subscribed" : "Subscribe Now"}
            btnClass={styles.submitBtn}
            outline={true}
            onClick={
              plan?.is_already_subscribed
                ? onSubscribed
                : () =>
                    navigate("/paymentMethods", {
                      state: plan,
                    })
            }
          />
        </Row>
      </Col>
      <Col xs={10} lg={9} className={styles.rightContainer}>
        <img src={subscriptionImage} alt="" />
      </Col>
    </Row>
  );
};

const Membership = () => {
  // const role = localStorage.getItem("role");
  const role = Storage.getERole("@role");
  const SubscriptionData = useSelector(
    (state) => state.PaymentReducer.allSubscriptions
  );
  // const [loader, setloader] = useState(true);
  console.log("SubscriptionData=======>>>>>>>", SubscriptionData);

  const dispatch = useDispatch();
  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    dispatch(PaymentMiddleware.getSubscriptions());
  };

  return (
    <Row
      justify={"center"}
      gutter={[20, 24]}
      style={{ justifyContent: "center" }}
    >
      {role === roles.client ? (
        <>
          {SubscriptionData?.map((plan) => (
            <Col xs={24} lg={18}>
              <MembershipComp plan={plan} />
            </Col>
          ))}
        </>
      ) : (
        <>
          {SubscriptionData?.map((plan) => (
            <Col xs={24} lg={12}>
              <MembershipComp plan={plan} />
            </Col>
          ))}
        </>
      )}
    </Row>
  );
};

export default Membership;
